module.exports = __webpack_public_path__ + "1642699981952/static/media/authBastaoAzulMobile.e81839d7.svg";